<template>
  <div class="hello">
      <div class="container margin_60_35">
          <div class="row">
            <SideCategory/>
            <MenuLists/>
            <Order/>
          </div>
      </div>
  </div>  
</template>

<script>
import SideCategory from "@/components/SideCategory.vue";
import MenuLists from "@/components/MenuLists.vue";
import Order from "@/components/Order.vue";

export default {
  name: 'MainContent',
  components:{
    SideCategory,
    MenuLists,
    Order
  },
  methods: {
    stickey(){
      var top = $('#sidebar-category').offset().top - parseFloat($('#sidebar-category').css('marginTop').replace(/auto/, 0));
      var footTop = $('#footer').offset().top - parseFloat($('#footer').css('marginTop').replace(/auto/, 0));
      var maxY = footTop - $('#sidebar-category').outerHeight();
      $(window).scroll(function(evt) {
        var y = $(this).scrollTop();
        if (y > top) {
          //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant 
          if (y < maxY) {
              $('#sidebar-category').addClass('fixed').removeAttr('style');
          } else {
                
            //Quand la sidebar-category arrive au footer, supprime la classe "fixed" précèdement ajouté
            $('#sidebar-category').removeClass('fixed').css({
                position: 'relative',
                top: '0px',
                bottom: '0px'
            });
            }
        } else {
          $('#sidebar-category').removeClass('fixed');
        }
      });
    },
    stickeyOrder(){
      var top = $('#sidebar-order').offset().top - parseFloat($('#sidebar-order').css('marginTop').replace(/auto/, 0));
      var footTop = $('#footer').offset().top - parseFloat($('#footer').css('marginTop').replace(/auto/, 0));
      var maxY = footTop - $('#sidebar-order').outerHeight();
      $(window).scroll(function(evt) {
        var y = $(this).scrollTop();
        if (y > top) {
          //Quand scroll, ajoute une classe ".fixed" et supprime le Css existant 
          if (y < maxY) {
              $('#sidebar-order').addClass('fixed').removeAttr('style');
          } else {
                
            //Quand la sidebar-order arrive au footer, supprime la classe "fixed" précèdement ajouté
            $('#sidebar-order').removeClass('fixed').css({
                position: 'relative',
                top: '0px',
                bottom: '0px'
            });
            }
        } else {
          $('#sidebar-order').removeClass('fixed');
        }
      });
    }
  },
  mounted() {
    if(window.innerWidth < 300){
      this.stickey()
      this.stickeyOrder()
    }
    
  },
}
</script>
<style>
 
</style>
